import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M.944 13.913A19.982 19.982 0 0 0 0 20c0 2.122.332 4.167.944 6.087l19.056.87 19.056-.87A19.99 19.99 0 0 0 40 20a20 20 0 0 0-.944-6.087L20 13.043l-19.056.87Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#000",
  d: "M40 20a20.13 20.13 0 0 0-.302-3.478H.302a20.106 20.106 0 0 0 0 6.956h39.396c.198-1.13.302-2.292.302-3.478Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M20 40c8.923 0 16.48-5.844 19.056-13.913H.944C3.52 34.156 11.077 40 20 40Zm0-40C11.077 0 3.52 5.844.944 13.913h38.111C36.48 5.844 28.924 0 20 0Z"
}, null, -1), a = [
  n,
  c,
  s
];
function d(h, i) {
  return e(), o("svg", l, [...a]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
